// PropertiesPanel.js
import React,{useState} from 'react';
import './PropertiesPanel.css';
import LogicBuilderPopup from './LogicBuilderPopup';
import WYSIWYGEditor from './WYSIWYGEditor';
import HTMLTemplateEditor from './HTMLTemplateEditor';

const fontSizes = [6,7,8,9,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,44,48];
const fontWeights = ['100','200','300','400','500','600','800','Bold','Bolder','Normal']

const PropertiesPanel = ({ component, onUpdate, fields }) => {


  const [showLogicBuilder, setShowLogicBuilder] = useState(false);
  const [showWYSIWYG, setShowWYSIWYG] = useState(false);
  const [showHTMLTemplate, setShowHTMLTemplate] = useState(false);

  const handleLogicSave = (logicConditions) => {
    onUpdate({
      ...component,
      logic: logicConditions,
    });
    setShowLogicBuilder(false);
  };

  const handleWYSIWYGSave = (htmlContent) => {
    onUpdate({
      ...component,
      content: htmlContent,
    });
    setShowWYSIWYG(false);
  };

  const handleHTMLTemplateSave = (templateContent) => {
    onUpdate({
      ...component,
      template: templateContent,
    });
    setShowHTMLTemplate(false);
  };

  const handleTypeChange = (newType) => {
    onUpdate({
      ...component,
      type: newType,
    });
  };

  if (!component) return <div className="properties-panel">Select a field to edit</div>;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue;
    if (type === 'checkbox') {
      newValue = checked;
    } else if (type === 'number' || ( e.target.tagName === 'SELECT' && ['colSpan', 'page'].includes(name)) ) {
      newValue = parseInt(value, 10);
    } else {
      newValue = value;
    }

    onUpdate({ ...component, [name]: newValue });
  };



  const renderCommonProps = () => (
    <>
      <label>
        Label:
        <input type='text' name="label" value={component.label || ''} onChange={handleChange} />
      </label>
      <label>
        Placeholder:
        <input type='text'  name="placeholder" value={component.placeholder || ''} onChange={handleChange} />
      </label>
      <label>
        Name:
        <input type='text' name="name" value={component.name || ''} onChange={handleChange} />
      </label>
      <label>
        Page:
        <input type="number" name="page" value={component.page || 1} onChange={handleChange} />
      </label>
      <label>
        Data Level:
        <select  name="dataleval" value={component.datrenderCommonPropsalevel || 1 }  onChange={handleChange}  >
          <option value="">Select Data Level</option>
          <option value={1} >Company</option>
          <option value={2} >Director</option>
        </select>
      </label>
      <label>
        Col Span:
        <select name='colSpan' value={component.colSpan || 1} onChange={handleChange} >
            <option value={1} >1</option>
            <option value={2} >2</option>
            <option value={3} >3</option>
            <option value={4} >4</option>
        </select>
      </label>
      <label>
        Required:
        <input type="checkbox" name="required" checked={component.required || false} onChange={handleChange} />
      </label>
      <label>
        Show Required Indicator:
        <input type="checkbox" name="showRequiredIndicator" checked={component.showRequiredIndicator || false} onChange={handleChange} />
      </label>
      <label >
      Text Case:
        <select name='textCase' value={component.textCase || 1} onChange={handleChange} >
            <option value={'lower'} >Lower Case</option>
            <option value={'upper'} >UpperCase</option>
            <option value={'capitalize'} >Capitalize</option>
            <option value={'none'} >No Formatting</option>
        </select>

      </label>
      <label>
        Help Text:
        <textarea  name="helptext" value={component.helptext || ''} onChange={handleChange} ></textarea>

      </label>
    </>
  );

  const renderStyledTextProps = () => (
    <>
      <label>
        Content:
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <textarea
            name="content"
            value={component.content || ''}
            onChange={handleChange}
            readOnly
            onClick={() => setShowWYSIWYG(true)}
            placeholder="Click to open WYSIWYG editor..."
            style={{ cursor: 'pointer', flex: 1 }}
          />
          <button
            type="button"
            onClick={() => setShowWYSIWYG(true)}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Edit HTML
          </button>
        </div>
      </label>
      <label>
      Align Text:
        <select name="alignheading" value={component.alignheading || 'left'} onChange={handleChange}>
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </label>

      <label>
        Font Size:
        <select name="fontSize" value={component.fontSize || '10pt'} onChange={handleChange}>
          {fontSizes.map(item => (<option key={`fntsize_${item}`} value={`${item}pt`}>{item}pt</option>))}
        </select>
      </label>
      <label>
        Color:
        <div>
        <input name="color" value={component.color || '#000000'} onChange={handleChange} type="color" />
        </div>
      </label>
      <label>
        Font Weight:
        <select name="fontWeight" value={component.fontWeight || 'normal'} onChange={handleChange}>
          {fontWeights.map(item => (<option key={`fntweight_${item}`}  value={`${item.toLowerCase()}`}>{item}</option>))}
        </select>
      </label>
      <label>
        Styling:
        <input type='checkbox' name='italic' checked={component.italic || false}  onChange={handleChange} />&nbsp;<i>I</i>&nbsp;
        <input type='checkbox' name='underline' checked={component.underline || false}  onChange={handleChange} />&nbsp;<u>U</u>
      </label>
    </>
  );

  const renderHTMLTemplateProps = () => (
    <>
      <label>
        Template:
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <textarea
            name="template"
            value={component.template || ''}
            onChange={handleChange}
            readOnly
            onClick={() => setShowHTMLTemplate(true)}
            placeholder="Click to open HTML Template editor..."
            style={{ cursor: 'pointer', flex: 1, minHeight: '80px' }}
          />
          <button
            type="button"
            onClick={() => setShowHTMLTemplate(true)}
            style={{
              padding: '8px 16px',
              backgroundColor: '#17a2b8',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Edit Template
          </button>
        </div>
      </label>
    </>
  );

  const renderHeadingProps = () => (
    <>
      <label>
        Tag:
        <select name="tag" value={component.tag || 'h3'} onChange={handleChange}>
          <option value="h1">H1</option>
          <option value="h2">H2</option>
          <option value="h3">H3</option>
          <option value="h4">H4</option>
          <option value="h5">H5</option>
          <option value="h6">H6</option>
        </select>
      </label>
      <label>
        Align Heading:
        <select name="alignheading" value={component.alignheading || 'left'} onChange={handleChange}>
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </label>
      <label>
        Font Size:
        <input  type='text' name="fontSize" value={component.fontSize || '1.5em'} onChange={handleChange} />
      </label>
      <label>
        Color:
        <input name="color" value={component.color || '#000000'} onChange={handleChange} type="color" />
      </label>
      <label>
        Font Weight:
        <select name="fontWeight" value={component.fontWeight || 'bold'} onChange={handleChange}>
          <option value="normal">Normal</option>
          <option value="bold">Bold</option>
        </select>
      </label>
      <label>
        Margin:
        <input  type='text'  name="margin" value={component.margin || '10px 0'} onChange={handleChange} />
      </label>
    </>
  );

  const renderGroupProps = () => (
      <>
        <label>
          Group Label:
          <input type='text'  name="label" value={component.label || ''} onChange={handleChange} />
        </label>
        <label>
          Description (optional):
          <textarea name="description" value={component.description || ''} onChange={handleChange} />
        </label>
        <label>
          Border:
          <input
            type="checkbox"
            name="border"
            checked={component.border ?? true}
            onChange={handleChange}
          />
        </label>
      </>
  )

  const renderAddressProps = () => (
    <>
    <h5>Address Block</h5>
      <label>
        Address Type/Name:
        <input type='text'  name="addresstype" value={component.addresstype || ''} onChange={handleChange} />
      </label>
      <label>
          Maximum Addresses for this Block:
          <input type="number" name="maxaddrs" value={component.maxaddrs || 1 } onChange={handleChange} />
      </label>
      <label>
        Allow Show Use Registered Address:
        <input type='checkbox' name="allowuseregistered" checked={component.allowuseregistered || false } onChange={handleChange} />
      </label>
    </>
  )

  return (
    <div className="properties-panel">
      <h3>Edit Properties</h3>
      {renderCommonProps()}
      {(component.type === 'styledText' || component.type === 'html') && renderStyledTextProps()}
      {component.type === 'htmltemplateeditor' && renderHTMLTemplateProps()}
      {component.type === 'address' && renderAddressProps()}
      {component.type === 'heading' && renderHeadingProps()}
      {component.type === 'group' && renderGroupProps() }
      <hr />

      <h4>Logic Rules</h4>
      <button onClick={() => setShowLogicBuilder(true)}>Set Conditional Logic</button><br/>
      {component.logic && component.logic.length > 0 && (
        <><span style={{fontSize: '0.8rem', textDecoration: 'underline'}} >Logic Summary:</span>
        <ul className="logic-summary">
          {component.logic.map((cond, index) => (
            <li key={index} style={{margin: '2px 2px'}}>
              <strong>{cond.field}</strong> {cond.operator} "{cond.value}"
            </li>
          ))}
        </ul></>
      )}

      {showLogicBuilder && (
        <LogicBuilderPopup
          logic={component.logic || []}
          onSave={handleLogicSave}
          onClose={() => setShowLogicBuilder(false)}
          fields={fields}
        />
      )}

      {showWYSIWYG && (
        <WYSIWYGEditor
          isOpen={showWYSIWYG}
          initialValue={component.content || ''}
          onSave={handleWYSIWYGSave}
          onTypeChange={handleTypeChange}
          onClose={() => setShowWYSIWYG(false)}
        />
      )}

      {showHTMLTemplate && (
        <HTMLTemplateEditor
          isOpen={showHTMLTemplate}
          initialValue={component.template || ''}
          onSave={handleHTMLTemplateSave}
          onClose={() => setShowHTMLTemplate(false)}
          fields={fields}
        />
      )}
    </div>
  );
};

export default PropertiesPanel;
